module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-10-da5d54800127b5738545b7d068bf4f7e.jpg";